import { END_GAME } from '../game/constants/hud';
import { RESTART_RELOAD_MIN_DELAY_MS } from '../game/constants/feel';

export function restartReloadDelayMs(
  now: number,
  hasMatchInfo: boolean,
  matchInfoAt: number,
): number {
  if (!hasMatchInfo) return RESTART_RELOAD_MIN_DELAY_MS;
  return Math.max(RESTART_RELOAD_MIN_DELAY_MS, matchInfoAt + END_GAME.lifetimeMs - now);
}
